<div id="attribute">
  <div class="title-head" fxLayout="row" fxLayoutAlign="space-between center" color="primary">
    <span>
      New Product Attribute
    </span>
    <button [attr.guide]="'configurable-product-btn-1' + '__' + sanitizedUrl" mat-icon-button>
      <mat-icon (click)="close()">
        close
      </mat-icon>
    </button>
  </div>
  </div>
  <mat-dialog-content class="mat-typography">
  <div class="padding-11" style="overflow-x: auto;">
    <div class="editSets" fxLayout="column">
      <mat-stepper style="padding: 0px; margin-left: 0px;" orientation="vertical" fxFlex [linear]="isLinear" #stepper>
        <mat-step style="padding: 0px; margin-left: 0px;" >  

          <ng-template matStepLabel>Select Attributes </ng-template>

          <calsoft-common-attribute
           (onConfirAttribute)=getSelectedAttribute($event) [entityTypeId]="4" [type]="'product'" [setId]="setId">
          </calsoft-common-attribute>
          <div fxLayout="row" fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center" fxLayoutGap="10px">
            <!-- <button [attr.guide]="'configurable-product-btn-2' + '__' + sanitizedUrl" (click)="goBack(stepper)" mat-raised-button>Back</button> -->
            <button [attr.guide]="'configurable-product-btn-3' + '__' + sanitizedUrl" (click)="goForward(stepper,1)" mat-raised-button color="primary">Next</button>
          </div>
        </mat-step>

        <mat-step label="Attribute Values ">

          <div fxLayout="column" fxLayoutGap="0px">
            <div style="border-radius: 0px;" class="br0" expanded
              *ngFor="let item of filterListMap | keyvalue;let i=index">
              <div>
                <mat-panel-title>
                  <h5> {{item.key | uppercase}}</h5>
                </mat-panel-title>

              </div>

              <div fxLayout="column" style="height: 129px;
              overflow-x: auto;" fxLayoutGap="5px" class="overflowY">
                <div class="padding-7" fxLayoutAlign="start center" *ngFor="let size1 of item.value ">
                  <mat-checkbox [attr.guide]="'configurable-product-chk-4' + '__' + sanitizedUrl" [checked]="attributeSelectedList.indexOf(size1) >= 0" (change)="filterColumn($event,item.key,i,size1)" [value]="size1" color="primary">{{size1 |
                    uppercase}}
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </div>

          <ng-template matStepLabel>Attribute Values </ng-template>
          <div fxLayout="row" fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center" fxLayoutGap="10px">
            <button [attr.guide]="'configurable-product-btn-5' + '__' + sanitizedUrl" (click)="goForward(stepper,2)" mat-raised-button color="primary">Next</button>
            <button [attr.guide]="'configurable-product-btn-6' + '__' + sanitizedUrl" (click)="goBack(stepper,2)" mat-raised-button>Back</button>
        
          </div>

        </mat-step>



        <!-- <mat-step label="Bulk Images & Price">

        <ng-template matStepLabel>Bulk Images & Price</ng-template>
        <div fxLayout="row" fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center" fxLayoutGap="10px">
            <button [attr.guide]="'configurable-product-btn-7' + '__' + sanitizedUrl" (click)="goBack(stepper)" mat-raised-button>Back</button> 
              <button [attr.guide]="'configurable-product-btn-8' + '__' + sanitizedUrl" (click)="goForward(stepper)" mat-raised-button
                  color="primary">Next</button>
          </div>

    </mat-step> -->


        <mat-step label="Summary">

          <ng-template matStepLabel>Summary</ng-template>

          <div id="attribute">

            <div class="padding-11" style="overflow-x: auto;">
              <div class="editSets" fxLayout="column">
                <calsoft-list  [displayColumnRequired]="'false'" [progress]="spinner"
                 (filterChangeColumn)="onFilterChangeColumn($event)"
                  name="Select Associated Product" [columns]="columns"
                  (filterChange)="onFilterChange($event)" style="margin-bottom: 0px;">

                  <div id="responsieTable" class="container">
                    <div [ngClass]="filterAttributeList.length>=5?'minimum':'none'">
                      <table class="rwd-table">
                        <tbody>
                          <tr>
                            <th></th>
                            <th>Name</th>
                            <th>SKU</th>
                          </tr>
                          <tr *ngFor="let product of filterAttributeList;let i=index">
                            <td data-th="">
                              <mat-checkbox [attr.guide]="'configurable-product-chk-9' + '__' + sanitizedUrl" [checked]="associatedProductList.indexOf(product.entityId) >= 0" 
                                (change)="onChange($event.checked,product)">
                              </mat-checkbox>
                            </td>
                            <td data-th="name">
                              {{product.name | slice:0:40}}
                            </td>
                            <td data-th="sku">
                              {{product.sku }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div fxLayout="row"  class="products-padding" *ngIf="filterAttributeList.length==0" fxLayoutAlign="center center">
                        <span>No Records Found</span>
                      </div>
                    </div>
                  </div>

                  <div fxLayout="row" class="pager" fxLayoutAlign="end center" fxLayoutGap="5px">
                    <mat-spinner [diameter]="20" *ngIf="spinner"></mat-spinner>
                    <mat-paginator class="paginator" (page)="getUpdate($event)" showFirstLastButtons [length]="pageList"
                      [pageIndex]="page" [pageSize]="size" [pageSizeOptions]="pageSizeValue">
                    </mat-paginator>
                  </div>
                </calsoft-list>
              </div>
              <!-- <div class="padding-top10 " fxLayoutGap="10px">
                <button [attr.guide]="'configurable-product-btn-10' + '__' + sanitizedUrl" type="button" mat-raised-button (click)="addSelectedAttribute()">OK
                </button>
            </div> -->
            </div>
          </div>


          <div fxLayout="row" fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center" fxLayoutGap="10px">
            <button [attr.guide]="'configurable-product-btn-11' + '__' + sanitizedUrl" *ngIf="filterAttributeList.length>0" (click)="goForward(stepper,3)" mat-raised-button color="primary">Next</button>
            <button [attr.guide]="'configurable-product-btn-12' + '__' + sanitizedUrl" (click)="goBack(stepper,3)" mat-raised-button>Back</button>
         
          </div>
        </mat-step>

        <mat-step>

          <ng-template matStepLabel> Images & Price & Stock & Image Configuration
          </ng-template>
          <div class="editSets1 padding-10"  [formGroup]="secondFormGroup">
            <div class="title " fxLayout="row" fxLayoutAlign="start center">
                <span>Properties</span>
            </div>
            <div class="products-padding">
                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">

                    <mat-form-field appearance="outline" fxFlex="100%" fxFlex.gt-sm>
                        <mat-label>Manage Stock Separately
                        </mat-label>
                        <mat-select [disableOptionCentering]="true"
                             formControlName="manageStockSeperately">
                            <mat-option *ngFor="let item  of booleanField"
                                [value]="item.value">
                                {{item .viewValue}}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngFor="let validation of attributeProperyValidations.manageStockSeperately">
                            <mat-error class="error-message"
                                *ngIf="secondFormGroup.get('manageStockSeperately').hasError(validation.type) && (secondFormGroup.get('manageStockSeperately').dirty || secondFormGroup.get('manageStockSeperately').touched) ">
                                {{validation.message}}
                            </mat-error>
                        </mat-error>

                    </mat-form-field>

                </div>

                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">

                  <mat-form-field appearance="outline" fxFlex="100%" fxFlex.gt-sm>
                      <mat-label>Manage Price Separately
                      </mat-label>
                      <mat-select [disableOptionCentering]="true"
                           formControlName="managePriceSeperately">
                          <mat-option *ngFor="let item  of booleanField"
                              [value]="item.value">
                              {{item .viewValue}}
                          </mat-option>
                      </mat-select>
                      <mat-error
                          *ngFor="let validation of attributeProperyValidations.managePriceSeperately">
                          <mat-error class="error-message"
                              *ngIf="secondFormGroup.get('managePriceSeperately').hasError(validation.type) && (secondFormGroup.get('managePriceSeperately').dirty || secondFormGroup.get('managePriceSeperately').touched) ">
                              {{validation.message}}
                          </mat-error>
                      </mat-error>

                  </mat-form-field>

              </div>

              <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">

                <mat-form-field appearance="outline" fxFlex="100%" fxFlex.gt-sm>
                    <mat-label>Manage Image Separately
                    </mat-label>
                    <mat-select [disableOptionCentering]="true"
                         formControlName="manageImageSeperately">
                        <mat-option *ngFor="let item  of booleanField"
                            [value]="item.value">
                            {{item .viewValue}}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngFor="let validation of attributeProperyValidations.manageImageSeperately">
                        <mat-error class="error-message"
                            *ngIf="secondFormGroup.get('manageImageSeperately').hasError(validation.type) && (secondFormGroup.get('manageImageSeperately').dirty || secondFormGroup.get('manageImageSeperately').touched) ">
                            {{validation.message}}
                        </mat-error>
                    </mat-error>

                </mat-form-field>

            </div>

            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">

              <mat-form-field appearance="outline" fxFlex="100%" fxFlex.gt-sm>
                  <mat-label>Manage Description Separately
                  </mat-label>
                  <mat-select [disableOptionCentering]="true"
                       formControlName="manageDescriptionSeperately">
                      <mat-option *ngFor="let item  of booleanField"
                          [value]="item.value">
                          {{item .viewValue}}
                      </mat-option>
                  </mat-select>
                  <mat-error
                      *ngFor="let validation of attributeProperyValidations.manageDescriptionSeperately">
                      <mat-error class="error-message"
                          *ngIf="secondFormGroup.get('manageDescriptionSeperately').hasError(validation.type) && (secondFormGroup.get('manageDescriptionSeperately').dirty || secondFormGroup.get('manageDescriptionSeperately').touched) ">
                          {{validation.message}}
                      </mat-error>
                  </mat-error>

              </mat-form-field>

          </div>

          <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">

            <mat-form-field appearance="outline" fxFlex="100%" fxFlex.gt-sm>
                <mat-label>Manage Additional Information Separately
                </mat-label>
                <mat-select [disableOptionCentering]="true"
                     formControlName="manageAdditionalInformationSeperately">
                    <mat-option *ngFor="let item  of booleanField"
                        [value]="item.value">
                        {{item .viewValue}}
                    </mat-option>
                </mat-select>
                <mat-error
                    *ngFor="let validation of attributeProperyValidations.manageAdditionalInformationSeperately">
                    <mat-error class="error-message"
                        *ngIf="secondFormGroup.get('manageAdditionalInformationSeperately').hasError(validation.type) && (secondFormGroup.get('manageAdditionalInformationSeperately').dirty || secondFormGroup.get('manageAdditionalInformationSeperately').touched) ">
                        {{validation.message}}
                    </mat-error>
                </mat-error>

            </mat-form-field>

        </div>

        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">

          <mat-form-field appearance="outline" fxFlex="100%" fxFlex.gt-sm>
              <mat-label>Manage Name Separately
              </mat-label>
              <mat-select [disableOptionCentering]="true"
                   formControlName="manageNameSeperately">
                  <mat-option *ngFor="let item  of booleanField"
                      [value]="item.value">
                      {{item .viewValue}}
                  </mat-option>
              </mat-select>
              <mat-error
                  *ngFor="let validation of attributeProperyValidations.manageNameSeperately">
                  <mat-error class="error-message"
                      *ngIf="secondFormGroup.get('manageNameSeperately').hasError(validation.type) && (secondFormGroup.get('manageNameSeperately').dirty || secondFormGroup.get('manageNameSeperately').touched) ">
                      {{validation.message}}
                  </mat-error>
              </mat-error>

          </mat-form-field>

      </div>




            </div>
        </div>
           
         
          <div fxLayout="row" class="padding-10" fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center" fxLayoutGap="10px">
            <button [attr.guide]="'configurable-product-btn-13' + '__' + sanitizedUrl" (click)="goForward(stepper,4)" mat-raised-button color="primary">Next</button>
            <button [attr.guide]="'configurable-product-btn-14' + '__' + sanitizedUrl" (click)="goBack(stepper,4)" mat-raised-button>Back</button> 
          
          </div>
        </mat-step>

        <mat-step>

          <ng-template matStepLabel>Summary</ng-template>

 
        <ng-container  *ngIf="visible">

          <calsoft-summary [associatedProductListProductConfigured]="associatedProductListProductConfigured"></calsoft-summary>
        </ng-container>

         
          <div fxLayout="row" fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center" fxLayoutGap="10px">
            <button [attr.guide]="'configurable-product-btn-15' + '__' + sanitizedUrl" (click)="finshPopup()" mat-raised-button color="primary">Finish</button>
            <button [attr.guide]="'configurable-product-btn-16' + '__' + sanitizedUrl" (click)="goBack(stepper,5)" mat-raised-button>Back</button> 
         
          </div>
        </mat-step> 



      </mat-stepper>


 </div>
 </div>

 </mat-dialog-content>

